<template>
  <div class="management-bd tb" v-if="funcView.msg_center_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-radio-group v-model="formSearch.msgClass" @change="onChangeTab">
            <el-radio-button type="primary" label plain>{{ $t('Common.com_all') }} {{ msgStatistics.totalCounts }}</el-radio-button>
            <template v-for="item in propertyMap.bas_msg_class">
              <el-radio-button :key="item.value" v-if="msgClass[item.value] != undefined" type="primary" :label="item.value" plain>
                {{ item.name }} {{ msgStatistics.msgClassCounts ? msgStatistics.msgClassCounts[item.value] || '' : '' }}
              </el-radio-button>
            </template>
          </el-radio-group>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <el-radio-group v-model="formSearch.isRead" @change="onPageChange({ page: 1 })">
            <el-radio-button type="primary" label plain>{{ $t('Common.com_all') }}</el-radio-button>
            <el-radio-button v-for="(item, index) in propertyMap.is_read" :key="index" :label="item.value">{{ item.name }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="$t('base_messageCenter.biao_ti_nei_rong')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right; width: 250px;">
           <custom-date-picker
            v-model="formSearch.sendTime"
            type="daterange"
            align="right"
            :picker-options="beforeToday"
            @change="onPageChange({ page: 1 })"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
        <!-- 消息分类 -->
        <el-form-item style="float: right;">
          <el-select v-model="formSearch.msgType" clearable :placeholder="$t('base_messageCenter.xiao_xi_lei_bie')" style="width: 200px;" @change="onPageChange({ page: 1 })">
            <el-option v-for="item in msgTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        type="checkbox"
        tableCode="messageCenter"
        v-model="msgListSelect"
        :data="msgList"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
        @change="controlBtn"
        height="100%"
        :slots="['title']"
      >
        <template slot="title" slot-scope="scope">
          <span @click="itemContent(scope.row)" style="color:#00a2df; cursor: pointer">{{ scope.row.title }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <el-form :inline="true" @submit.native.prevent style="float:left">
        <el-form-item>
          <el-checkbox v-model="isCheckAll" @change="onCheckAll" style="float: left;margin-right: 24px;"></el-checkbox>
          <el-button v-if="funcView.msg_center_mark_read" :disabled="markRead" @click="markReadbtn">{{ $t('base_messageCenter.biao_ji_yi_du') }}</el-button>
          <el-button v-if="funcView.msg_center_mark_all_read" @click="allReadbtn">{{ $t('base_messageCenter.quan_bu_yi_du') }}</el-button>
          <el-button v-if="funcView.msg_center_delete" :disabled="deleteRead" @click="deleteReadBtn">{{ $t('Common.com_delete') }}</el-button>
        </el-form-item>
      </el-form>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!--查看-->
    <message-item-dialog v-if="dialogVisible1" :model="dialogModel1" @success="getMsg" @close="dialogVisible1 = false"></message-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import messageItemDialog from './children/message_item_dialog';

export default {
  name: 'messageCenter',
  components: {
    messageItemDialog
  },
  data() {
    return {
      formSearch: {
        keyword: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        msgClass: '',
        msgType: '',
        isRead: '',
        sendTime: ''
      },

      totalRows: null,
      msgList: [],
      isCheckAll: false,
      msgListSelect: [],
      markRead: true,
      allRead: true,
      deleteRead: true,
      msgStatistics: {},
      msgClass: {},
      msgTypeList: [],

      // 新增/编辑
      dialogVisible1: false,
      dialogModel1: {},
      curRow: null
    };
  },
  computed: {
    messageNum() {
      return this.$store.state.messageNum;
    }
  },
  mounted() {
    // 消息类型
    this.getDictionary('bas_msg_class,is_read');
    this.getFuncView();

    this.getMsg();
    this.getMsgClass();
  },
  activated() {
    if (this.messageNum > 0) {
      this.getMsg();
    }
  },
  methods: {
    onChangeTab(item) {
      if (item) {
        const row = this.propertyMap.bas_msg_class.find(t => t.value === item);
        this.formSearch.msgType = '';
        this.msgTypeList = row ? row.children : [];
      } else {
        this.formSearch.msgType = '';
        this.msgTypeList = [];
      }
      this.onPageChange({ page: 1 });
    },
    // 获取当前账号分类
    getMsgClass: function () {
      this.$getJSON(apis.msgRecordClassList).then((res) => {
        this.msgClass = res.data;
      });
    },
    // 获取消息列表
    getMsg: function () {
      this.$getJSON(apis.msgRecordPage, this.formSearch).then((res) => {
        this.msgList = res.data.records;
        this.totalRows = res.data.total;
        this.getMsgStatistics();
      });
    },
    // 获取消息统计
    getMsgStatistics() {
      this.$getJSON(apis.msgRecordTotalInit).then((res) => {
        if (this.formSearch.isRead === '') {
          this.msgStatistics = res.data.allCounts;
        } else if (this.formSearch.isRead === 'true') {
          this.msgStatistics = res.data.readedCounts;
        } else {
          this.msgStatistics = res.data.unReadCounts;
        }
        // 刷新未读消息数
        const msgStatistics = res.data.unReadCounts.totalCounts || 0;
        this.$store.commit('MESSAGEWS', msgStatistics);
      });
    },
    // 全局全选事件
    onCheckAll: function (val) {
      // this.indeterminate = false;
      if (val) {
        this.$nextTick(() => {
          this.msgList.forEach((item, index) => {
            this.$refs.tb1.$emit('toggleRowSelection', this.msgList[index], true);
          });
        });
      } else {
        this.$nextTick(() => {
          this.$refs.tb1.$emit('clearSelection');
        });
      }
    },
    controlBtn() {
      this.markRead = true;
      this.allRead = true;
      this.deleteRead = true;
      this.msgListSelect.forEach((i) => {
        this.deleteRead = false;
        if (!i.isRead) {
          // 未读
          this.markRead = false;
          this.allRead = false;
        }
      });
    },
    markReadbtn() {
      const tpl = this.$t('base_messageCenter.nqdyjxzdxxbjwydm');
      this.$showConfirm(tpl)
        .then(() => {
          const ids = this.msgListSelect.map(i => i.messageId);
          this.$postJSON(apis.msgRecordRead, ids).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            // 更新
            this.getMsg();
          });
        })
        .catch(() => {});
    },
    allReadbtn() {
      this.$showConfirm(this.$t('base_messageCenter.nqdyjsyxxbjwydm'))
        .then(() => {
          this.$postJSON(apis.msgRecordReadAll).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            // 更新
            this.getMsg();
          });
        })
        .catch(() => {});
    },
    deleteReadBtn() {
      this.$showConfirm(this.$t('base_messageCenter.nqdyscxzdxxm'))
        .then(() => {
          const ids = this.msgListSelect.map(i => i.messageId);
          this.$postJSON(apis.msgRecordDelete, ids).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            // 更新
            this.getMsg();
          });
        })
        .catch(() => {});
    },
    // 查看
    itemContent: function (row) {
      this.curRow = row;
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('base_messageCenter.xiao_xi_xiang_qing');
      this.dialogModel1.type = 'see';
      this.dialogModel1.data = row;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getMsg();
    }
  }
};
</script>

<style lang="scss">
@import '../../../style/colors.scss';
</style>
